import React, { useState, useContext } from "react";
import { Container, NavLink, Nav, NavItem, TabContent, TabPane } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import FeedbackContext from "src/context/UserFeedbackCount";
import classnames from "classnames";

// Import the new tab components
import SessionFeedbackTab from "./components/SessionFeedbackTab";
import ClinicalDirectorContactRequestTab from "./components/ClinicalDirectorContactRequestTab";
import TherapistRequestTab from "./components/TherapistRequestTab";

const ViewSessionFeedback: React.FC = () => {
  // Context & state
  const [userFeedbackCount, setUserFeedbackCount] = useContext(FeedbackContext);
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Session Feedback"} breadcrumbItem={"Session Feedback"} />
          
          <Nav tabs className="mb-0" style={{ borderBottom: '2px solid #dee2e6' }}>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '1' })}
                onClick={() => { toggle('1'); }}
                style={{ 
                  cursor: 'pointer', 
                  backgroundColor: activeTab === '1' ? 'white' : '#e9ecef',
                  color: 'black',
                  fontWeight: activeTab === '1' ? 'bold' : 'normal',
                  padding: '12px 20px',
                  borderRadius: '5px 5px 0 0',
                  marginRight: '5px',
                  border: '1px solid #dee2e6',
                  borderBottom: activeTab === '1' ? '0' : '1px solid #dee2e6'
                }}
              >
                SESSION FEEDBACK
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '2' })}
                onClick={() => { toggle('2'); }}
                style={{ 
                  cursor: 'pointer', 
                  backgroundColor: activeTab === '2' ? 'white' : '#e9ecef',
                  color: 'black',
                  fontWeight: activeTab === '2' ? 'bold' : 'normal',
                  padding: '12px 20px',
                  borderRadius: '5px 5px 0 0',
                  marginRight: '5px',
                  border: '1px solid #dee2e6',
                  borderBottom: activeTab === '2' ? '0' : '1px solid #dee2e6'
                }}
              >
                CLINICAL DIRECTOR CONTACT REQUEST
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '3' })}
                onClick={() => { toggle('3'); }}
                style={{ 
                  cursor: 'pointer', 
                  backgroundColor: activeTab === '3' ? 'white' : '#e9ecef',
                  color: 'black',
                  fontWeight: activeTab === '3' ? 'bold' : 'normal',
                  padding: '12px 20px',
                  borderRadius: '5px 5px 0 0',
                  border: '1px solid #dee2e6',
                  borderBottom: activeTab === '3' ? '0' : '1px solid #dee2e6'
                }}
              >
                THERAPIST REQUEST
              </NavLink>
            </NavItem>
          </Nav>
          
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <SessionFeedbackTab />
            </TabPane>
            <TabPane tabId="2">
              <ClinicalDirectorContactRequestTab />
            </TabPane>
            <TabPane tabId="3">
              <TherapistRequestTab />
            </TabPane>
          </TabContent>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewSessionFeedback;

